export const isEmbedded = () => window.self !== window.top


